import React from 'react';

import classes from '../installPics.css';

import Photo from '../../../../../../../assets/Fronius.jpg';

const Image = () => (
    <div className={classes.installImages}>
        <img alt="Fronius String Inverters" src={Photo} className={classes.installImg} />
    </div>
);


export default Image;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/Inverters/Fronius.js